import React from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'

const PolicyPage = ({ title, children, className }) => {
  return (
    <div className={classNames(styles.policyPage, className)}>
      <div className={styles.policyContainer}>
        <div className={styles.policyHeader}>
          <h1 className={styles.policyTitle}>{title}</h1>
        </div>
        
        <div className={styles.policyContent}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default PolicyPage
